import { IItem } from "./IItem";

export interface IExternalScriptAssociatable extends IItem {
  name: string;
  getValueForExternalScript(): string;
  setValueFromExternalScript(value: string): void;
  adjustFontSize(): void;
}

export function instanceOfIExternalScriptAssociatable(instance: any): instance is IExternalScriptAssociatable {
  return instance
    && (instance.getValueForExternalScript !== undefined)
    && (instance.setValueFromExternalScript !== undefined)
    && (instance.adjustFontSize !== undefined);
}
